import LogoHeader from '../LogoHeader'
// import s from './Header.module.css'

export default function Header(){
    return (
        <>
            <header >
                <LogoHeader/>       
            </header>
            
         </>
    )
}